/* eslint-disable */

import IconLocked from "../icon-lock/icon-lock";

import { Link } from "react-router-dom";

const SettingsElement = ({
  id,
  title,
  icon,
  iconColor = "",
  value = null,
  isLocked = false,
  to = "/raindrop/settings",
  isClickable = false,
  onClick = () => {},
}) => {
  let hover = "";
  let backgroundColor = "transparent";

  let rounded = "";
  let opacity = "opacity-100";
  let iconElement = null;
  iconColor = iconColor ? iconColor : "text-blue-400";

  if (icon) {
    iconElement = <i className={`${icon} text-2xl w-8 ${iconColor}`} />;
  }
  if (isLocked) {
    hover = "cursor-default";
    opacity = "opacity-50";
    // iconElement = <IconLocked className={"w-6 fill-white opacity-60"} />;
    iconElement = <i className={`fas fa-lock text-xl w-8 ${iconColor}`} />;
    to = "#";
    onClick = () => {};
  }
  if (!isClickable) {
    hover = "";
    to = "#";
  }

  return (
    <Link
      id={id}
      to={to}
      className={`flex flex-row w-full py-3 gap-3 text-color-text-primary  dark:text-color-dark-text-primary transition-all items-center ${hover} ${backgroundColor} ${rounded} group`}
      onClick={onClick}
    >
      {iconElement && <div className={`${opacity}`}>{iconElement}</div>}
      <div className={`${opacity}  font-bold`}>{title}</div>
      <div className={"ml-auto text-color-dark-text-secondary"}>{value}</div>
      {isClickable && (
        <i className="fas fa-chevron-right text-color-dark-text-secondary md:group-hover:pr-2 transition-all" />
      )}
    </Link>
  );
};

export default SettingsElement;
